import {Component, OnInit, inject} from '@angular/core';
import {CryptoService} from '../../../global/services/crypto.service';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataService} from '../../../global/services/data.service';
import {UserService} from '../../../global/services/user.service';
import Swal from 'sweetalert2';
import {ViewMode} from '../../../interfaces';
import {NgIf} from '@angular/common';
import {RightPipe} from '../../../global/pipes/right.pipe';
import {TooltipDirective} from "ngx-bootstrap/tooltip";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-task-topic-detail',
    templateUrl: './task-topic-detail.component.html',
    styleUrl: './task-topic-detail.component.scss',
    imports: [NgIf, FormsModule, ReactiveFormsModule, RightPipe, TooltipDirective]
})
export class TaskTopicDetailComponent implements OnInit {

    userService = inject(UserService);
    private cryptoService = inject(CryptoService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    TOID!: string;
    viewMode!: ViewMode;
    topic: any;

    ngOnInit(): void {
        const urlData = this.cryptoService.getUrlData(this.router.url);
        this.TOID = urlData.ID;
        this.viewMode = urlData.viewMode;

        this.form = this.fb.group({
            TOID: [null],
            name: ['', Validators.required],
        });

        if (this.TOID !== '0') {
            this.getTopic();
        }
    }

    getTopic(): void {
        this.dataService.request('TaskTopic/get', {TOID: this.TOID}).subscribe(response => {
            this.topic = response.topic;
            this.topic.used = parseInt(this.topic.used, 10);

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            TOID: this.topic.TOID,
            name: this.topic.name,
        });
    }

    save(): void {
        this.dataService.request('TaskTopic/save', this.form.getRawValue()).subscribe(() => {
            this.toastrService.success('Aufgabenthema wurde gespeichert');
            this.router.navigate(['/app/tasktopic']);
        });
    }

    update(): void {
        this.dataService.request('TaskTopic/update', this.form.getRawValue()).subscribe(() => {
            this.toastrService.success('Aufgabenthema wurde aktualisiert');
            this.setMode(ViewMode.VIEW);
        });
    }

    cancel(): void {
        this.router.navigate(['/app/tasktopic']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Das Aufgabenthema wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('TaskTopic/delete', {
                    TOID: this.TOID
                }).subscribe(() => {
                    this.toastrService.success('Aufgabenthema wurde gelöscht');
                    this.cancel();
                });
            }
        });
    }
}
